import { render, staticRenderFns } from "./roleManage.vue?vue&type=template&id=7cb389ef&scoped=true"
import script from "./roleManage.vue?vue&type=script&lang=js"
export * from "./roleManage.vue?vue&type=script&lang=js"
import style0 from "./roleManage.vue?vue&type=style&index=0&id=7cb389ef&prod&lang=scss&scoped=true"
import style1 from "./roleManage.vue?vue&type=style&index=1&id=7cb389ef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb389ef",
  null
  
)

export default component.exports